import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { putArista, deleteNodo } from "../routing/routes";

const VerNodo = ({
  nodos,
  refreshData,
  functionesChatbot,
  setNotification,
  permisos,
}) => {
  const { id } = useParams();
  const nodo = nodos.find((nodo) => nodo._id === id);

  if (nodo) {
    return (
      <Nodo
        id={id}
        nodo={nodo}
        nodos={nodos}
        refreshData={refreshData}
        setNotification={setNotification}
        functionesChatbot={functionesChatbot}
        permisos={permisos}
      />
    );
  } else {
    return <p>Loading...</p>;
  }
};

function toggle_variable(parametro) {
  if (parametro[0] === "&") {
    parametro = parametro.slice(1, -1);
  } else {
    parametro = "&" + parametro + "*";
  }
  return parametro;
}

const Nodo = ({
  id,
  nodo,
  nodos,
  refreshData,
  functionesChatbot,
  setNotification,
  permisos,
}) => {
  const [nodoNuevo, nuevoNodoChanged] = useState(nodo);
  const history = useHistory();

  useEffect(() => {
    nuevoNodoChanged(nodo);
  }, [nodo]);

  return (
    <div style={{ textAlign: "center" }}>
      <div className="centered-flex" style={{ backgroundColor: "#2536462b" }}>
        {permisos.eliminarNodo && (
          <DeleteNodo
            id={id}
            setNotification={setNotification}
            refreshData={refreshData}
          />
        )}
        <div className={"centered-flex2"}>
          <div>
            <h3>Nodo {nodo.nodo}</h3>
            <p>{nodo.nombre}</p>
            <div style={{ padding: "10px 0 -0 80px", marginBottom: "0" }}>
              <button
                className={
                  "nodo-button " + (nodo.nodoInicial && "nodo-button-green")
                }
                onClick={() => cambiaTipoNodo(nodo, "inicial")}
              >
                Inicial
              </button>
              <button
                className={
                  "nodo-button " +
                  (!nodo.nodoInicial && !nodo.nodoFinal && "nodo-button-normal")
                }
                onClick={() => cambiaTipoNodo(nodo, "normal")}
              >
                Normal
              </button>
              <button
                className={
                  "nodo-button " + (nodo.nodoFinal && "nodo-button-red")
                }
                onClick={() => cambiaTipoNodo(nodo, "final")}
              >
                Final
              </button>
            </div>
          </div>
          <div style={{ marginLeft: 80 }}>
            <h4>Aristas</h4>
            {nodo.aristas.map((arista, index) => (
              <Arista
                key={index}
                nodos={nodos}
                arista={arista}
                id={nodo._id}
                index={index}
                history={history}
                borrar={() => borrarArista(nodo, index)}
                permisos={permisos}
              />
            ))}
            {permisos.crearArista && (
              <Link to={"/new_connection/" + nodo._id}>
                <button className="add-button rectangle">+</button>
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className="container-funciones">
        <FunctionNodo
          nodoNuevo={nodoNuevo}
          nuevoNodoChanged={nuevoNodoChanged}
          functionesChatbot={functionesChatbot}
        />
        <SaveDelete
          nodoNuevo={nodoNuevo}
          nuevoNodoChanged={nuevoNodoChanged}
          setNotification={setNotification}
          refreshData={refreshData}
        />
      </div>
    </div>
  );

  function cambiaTipoNodo(nodo, cambio) {
    if (window.confirm("¿Estás seguro que quieres cambiar el tipo de nodo?")) {
      if (cambio === "inicial") {
        nodo.nodoInicial = true;
        nodo.nodoFinal = false;
      } else if (cambio === "final") {
        nodo.nodoInicial = false;
        nodo.nodoFinal = true;
      } else {
        nodo.nodoInicial = false;
        nodo.nodoFinal = false;
      }
      const id = nodo._id;
      delete nodo._id;
      putArista(id, nodo).then(() => refreshData());
    }
  }

  function borrarArista(nodo, index) {
    if (
      window.confirm("¿Estás seguro que quieres borrar esta arista? " + index)
    ) {
      nodo.aristas = [
        ...nodo.aristas.slice(0, index),
        ...nodo.aristas.slice(index + 1),
      ];
      const id = nodo._id;
      delete nodo._id;
      putArista(id, nodo).then(() => refreshData());
    }
  }
};

const Arista = ({ arista, id, index, history, nodos, borrar, permisos }) => {
  const nombreNodoConectado = nodos.find(
    (nodo) => nodo.nodo === arista.nodoDestino
  ).nombre;
  return (
    <div style={{ minWidth: 500, margin: 10 }}>
      <small>
        Conexión al nodo {arista.nodoDestino} ({nombreNodoConectado})
      </small>
      <div style={{ display: "inline" }} align="right">
        {permisos.modificarAristas && (
          <button
            onClick={() => history.push("/edit_connection/" + id + "/" + index)}
            className="edit-button"
            align="right"
          >
            &#9998;
          </button>
        )}

        {permisos.eliminarArista && (
          <button onClick={borrar} className="remove-button">
            x
          </button>
        )}
      </div>
    </div>
  );
};

export default VerNodo;

// nuevoIntentChanged({...nuevoIntent, frases:[...nuevoIntent.frases.slice(0,index),...nuevoIntent.frases.slice(index+1)]})

const funcionDefault = { nombreFuncion: "", guardarEn: "", parametros: [] };

function FunctionNodo({ nodoNuevo, nuevoNodoChanged, functionesChatbot }) {
  return (
    <div style={{ textAlign: "left", width: "100%", marginTop: "5px" }}>
      <div>
        <h3>Funciones que Ejecuta</h3>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          flexWrap: "wrap",
        }}
      >
        {nodoNuevo.ejecutaFuncion &&
          nodoNuevo.ejecutaFuncion.map((funcion, index) => {
            return (
              <div key={index} style={{ margin: "10px" }}>
                <button
                  onClick={() => {
                    const temp = { ...nodoNuevo };

                    if (temp.ejecutaFuncion.length === 1) {
                      delete temp.ejecutaFuncion;
                    } else {
                      temp.ejecutaFuncion = [
                        ...temp.ejecutaFuncion.slice(0, index),
                        ...temp.ejecutaFuncion.slice(index + 1),
                      ];
                    }

                    nuevoNodoChanged(temp);
                  }}
                  className="remove-button"
                  style={{ marginLeft: "0px" }}
                >
                  x
                </button>
                <br />
                <small>Nombre de la función</small>
                <br />
                <select
                  onChange={(e) =>
                    nuevoNodoChanged({
                      ...nodoNuevo,
                      ejecutaFuncion: [
                        ...nodoNuevo.ejecutaFuncion.slice(0, index),
                        {
                          ...nodoNuevo.ejecutaFuncion[index],
                          nombreFuncion: e.target.value,
                        },
                        ...nodoNuevo.ejecutaFuncion.slice(index + 1),
                      ],
                    })
                  }
                  value={nodoNuevo.ejecutaFuncion[index].nombreFuncion}
                >
                  <option key="" value="">
                    Selecciona un archivo
                  </option>
                  {functionesChatbot.map((funcion) => (
                    <option key={funcion} value={funcion}>
                      {funcion}
                    </option>
                  ))}
                </select>
                <br />
                <small>Parámetros</small>
                {funcion.parametros &&
                  funcion.parametros.map((parametro, index2) => {
                    return (
                      <div key={index2}>
                        <input
                          onChange={(e) =>
                            nuevoNodoChanged({
                              ...nodoNuevo,
                              ejecutaFuncion: [
                                ...nodoNuevo.ejecutaFuncion.slice(0, index),
                                {
                                  ...nodoNuevo.ejecutaFuncion[index],
                                  parametros: [
                                    ...nodoNuevo.ejecutaFuncion[
                                      index
                                    ].parametros.slice(0, index2),
                                    e.target.value,
                                    ...nodoNuevo.ejecutaFuncion[
                                      index
                                    ].parametros.slice(index2 + 1),
                                  ],
                                },
                                ...nodoNuevo.ejecutaFuncion.slice(index + 1),
                              ],
                            })
                          }
                          value={
                            nodoNuevo.ejecutaFuncion[index].parametros[index2]
                          }
                        />

                        <button
                          onClick={() =>
                            nuevoNodoChanged({
                              ...nodoNuevo,
                              ejecutaFuncion: [
                                ...nodoNuevo.ejecutaFuncion.slice(0, index),
                                {
                                  ...nodoNuevo.ejecutaFuncion[index],
                                  parametros: [
                                    ...nodoNuevo.ejecutaFuncion[
                                      index
                                    ].parametros.slice(0, index2),
                                    toggle_variable(
                                      nodoNuevo.ejecutaFuncion[index]
                                        .parametros[index2]
                                    ),
                                    ...nodoNuevo.ejecutaFuncion[
                                      index
                                    ].parametros.slice(index2 + 1),
                                  ],
                                },
                                ...nodoNuevo.ejecutaFuncion.slice(index + 1),
                              ],
                            })
                          }
                          className="toggle-button"
                          style={{ wordWrap: "unset" }}
                        >
                          {parametro[0] === "&"
                            ? "Convertir a constante"
                            : "Convertir a variable"}
                        </button>

                        <button
                          onClick={() => {
                            const aristaTemp = { ...nodoNuevo };
                            const funcion = aristaTemp.ejecutaFuncion[index];

                            funcion.parametros = [
                              ...funcion.parametros.slice(0, index2),
                              ...funcion.parametros.slice(index2 + 1),
                            ];

                            aristaTemp.ejecutaFuncion[index] = funcion;

                            nuevoNodoChanged(aristaTemp);
                          }}
                          className="remove-button"
                          style={{ marginLeft: "5px" }}
                        >
                          x
                        </button>
                      </div>
                    );
                  })}
                <button
                  onClick={() =>
                    nuevoNodoChanged({
                      ...nodoNuevo,
                      ejecutaFuncion: [
                        ...nodoNuevo.ejecutaFuncion.slice(0, index),
                        {
                          ...nodoNuevo.ejecutaFuncion[index],
                          parametros: nodoNuevo.ejecutaFuncion[index].parametros
                            ? [
                                ...nodoNuevo.ejecutaFuncion[index].parametros,
                                "",
                              ]
                            : [""],
                        },
                        ...nodoNuevo.ejecutaFuncion.slice(index + 1),
                      ],
                    })
                  }
                  className="add-button rectangle"
                >
                  +
                </button>
              </div>
            );
          })}
        <button
          onClick={() =>
            nodoNuevo.ejecutaFuncion
              ? nuevoNodoChanged({
                  ...nodoNuevo,
                  ejecutaFuncion: [...nodoNuevo.ejecutaFuncion, funcionDefault],
                })
              : nuevoNodoChanged({
                  ...nodoNuevo,
                  ejecutaFuncion: [funcionDefault],
                })
          }
          className="add-button square"
        >
          +
        </button>
      </div>
    </div>
  );
}

function SaveDelete({ nodoNuevo, refreshData, setNotification }) {
  const history = useHistory();

  // Se valida que no haya funciones con nombres vacios
  const functionsValidation = nodoNuevo.ejecutaFuncion
    ? !nodoNuevo.ejecutaFuncion.every((funcion) => funcion.nombreFuncion !== "")
    : false;

  return (
    <div>
      <div className="form-actions" align="right">
        <button
          className="form-button secondary-button"
          onClick={() => history.push("/")}
        >
          Cancelar
        </button>
        <button
          disabled={functionsValidation}
          onClick={() => {
            const temp = { ...nodoNuevo };
            const id = temp._id;
            delete temp._id;
            putArista(id, temp)
              .then(() => {
                refreshData();
                setNotification("mSe modificó correctamente la arista");
              })
              .catch(() => {
                setNotification("eHubo un error almacenando la información");
              });
          }}
          className="form-button primary-button"
        >
          Guardar
        </button>
      </div>
      {functionsValidation && (
        <div align="right">
          <span style={{ fontSize: "12px", color: "red" }}>
            * Existen funciones sin nombre *
          </span>
        </div>
      )}
    </div>
  );
}

function DeleteNodo({ id, refreshData, setNotification }) {
  const history = useHistory();
  return (
    <div style={{ alignItems: "left", textAlign: "left" }}>
      <button
        onClick={() => {
          deleteNodo(id)
            .then(() => {
              refreshData();
              setNotification("mNodo eliminado correctamente");
              history.push(`/`);
            })
            .catch(() => {
              setNotification("eEl nodo no se pudo eliminar");
              history.push(`/`);
            });
        }}
        className="deleteNodo-button"
        align="left"
      >
        BORRAR
      </button>
    </div>
  );
}
